export const GET_USER = 'GET_USER';
export const GET_USERS_BY_IDS = 'GET_USERS_BY_IDS';
export const SUGGEST_USERS = 'SUGGEST_USERS';
export const GET_DIRECT_REPORTS = 'GET_DIRECT_REPORTS';
export const SET_ACTIVE_USER = 'SET_ACTIVE_USER';
export const UPDATE_ACTIVE_USER = 'UPDATE_ACTIVE_USER';
export const GET_USER_SYSTEMS = 'GET_USER_SYSTEMS';
export const GET_USER_SYSTEMS_ERROR = 'GET_USER_SYSTEMS_ERROR';
export const GET_USER_SYSTEMS_SUCCESS = 'GET_USER_SYSTEMS_SUCCESS';
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
export const GET_USER_PREFERENCES_ERROR = 'GET_USER_PREFERENCES_ERROR';
export const GET_USER_PREFERENCES_SUCCESS = 'GET_USER_PREFERENCES_SUCCESS';
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES';
export const UPDATE_USER_PREFERENCES_ERROR = 'UPDATE_USER_PREFERENCES_ERROR';
export const UPDATE_USER_PREFERENCES_SUCCESS = 'UPDATE_USER_PREFERENCES_SUCCESS';
export const GET_DIRECT_REPORTS_WITH_TIME = 'GET_DIRECT_REPORTS_WITH_TIME';
export const GET_DIRECT_REPORTS_WITH_TIME_ERROR = 'GET_DIRECT_REPORTS_WITH_TIME_ERROR';
export const GET_DIRECT_REPORTS_WITH_TIME_SUCCESS = 'GET_DIRECT_REPORTS_WITH_TIME_SUCCESS';
export const RESET_DIRECT_REPORTS_WITH_TIME = 'RESET_DIRECT_REPORTS_WITH_TIME';